import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import Body from "./Components/BodyComp/body";
import Navbar from "./Components/NavComp/nav";
import Footer from "./Components/FooterComp/footer";
import ContactUs from "./Components/ContactComp/contactus";
import AboutUs from "./Components/AboutComp/aboutus";
import FAQ from './Components/FAQComp/faq';

import WhatsAppButton from './Components/Whatsapp/WhatsAppButton';
import OurWork from './Components/OurWorkComp/ourwork';
import GetAQuote from './Components/GetQuoteComp/get-a-quote';
import AluminiumPantry from './Components/OurServicesComp/aluminium-pantry';
import AluminiumWindow from './Components/OurServicesComp/aluminium-window';
import Partition from './Components/OurServicesComp/partition';
import CurtainWalls from './Components/OurServicesComp/curtain-walls';
import RoofAndCeiling from './Components/OurServicesComp/roof-and-ceiling';
import WallCladding from './Components/OurServicesComp/wall-cladding';
import GlassDoorGlassPartition from './Components/OurServicesComp/glass-door-glass-partition';
import ScrollToTop from './ScrollComp/ScrollToTop';
import PreFabWarehouseBuilding from './Components/OurServicesComp/Pre fab warehouse building';
import ShowerCubicle from './Components/OurServicesComp/shower-cubicle';
import GreenHouses from './Components/OurServicesComp/green-houses';







function App() {
  return (
    <Router>
    <ScrollToTop />
    <Navbar />
    <Routes>
      <Route path="/" element={<Body />} />
      <Route path="/aboutus" element={<AboutUs />} />
      <Route path="/contactus" element={<ContactUs />} />
      <Route path="/ourwork" element={<OurWork />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="get-a-quote" element={<GetAQuote />} />
      <Route path="Pre fab warehouse building" element={<PreFabWarehouseBuilding />} />
      {/* <Route path="aluminium-pantry" element={<AluminiumPantry />} /> */}
      <Route path='aluminum-window' element={<AluminiumWindow />} />
      <Route path='partition' element={<Partition />} />
      <Route path='curtain-walls' element={<CurtainWalls />} />
      <Route path='roof-and-ceiling' element={<RoofAndCeiling />} />
      <Route path='wall-cladding' element={<WallCladding />} />
      <Route path='glass-door-glass-partition' element={<GlassDoorGlassPartition />} />
      <Route path='shower-cubicle' element={<ShowerCubicle />} />
      <Route path='green-houses' element={<GreenHouses />} />
  
    </Routes>
    <Footer /> 
<WhatsAppButton />
           
   
  </Router>
  );
}

export default App;

